import { makeAutoObservable } from "mobx";
import { Breakpoint } from "./models";
export class AppState {
    constructor() {
        this.homeUrl = "";
        this.rightMenuOpen = false;
        this.sideNavOpen = false;
        this.breakpoint = Breakpoint.lg;
        makeAutoObservable(this);
    }
    setHomeUrl(homeUrl) {
        this.homeUrl = homeUrl;
    }
    setSideNavOpen(open) {
        this.sideNavOpen = open;
    }
    setRightMenuOpen(rightMenuOpen) {
        this.rightMenuOpen = rightMenuOpen;
    }
    setBreakpoint(breakpoint) {
        this.breakpoint = breakpoint;
    }
}
